import { FetchClient } from "../../utils/fetchClient"

export async function getLuminSalesAcceleratorDetails(leadId) {
    return FetchClient(`/data/lumin/sales-accelerator-details?middleware_lead_id=${leadId}`).GET({})
}

export async function spinLuminSalesAccelerator(request) {
    return FetchClient(`/data/lumin/sales-accelerator`).POST({ payload: JSON.stringify(request) })
}
